export default "__VITE_ASSET__CVMIJ1Le__"